import { css, cx } from "@emotion/css"

import { PAGE_SIZE } from "api/utils"
import Skeleton from "@material-ui/lab/Skeleton"

const styles = {
  root: css`
    padding: 2rem 0;
    min-height: calc(var(--rows) * 20px);
  `,
  grid: css`
    display: grid;
    grid-template-columns: repeat(var(--cols), 1fr);
    grid-template-rows: repeat(var(--rows), 20px);
    grid-auto-rows: 20px;
    grid-column-gap: 1rem;
    grid-row-gap: 0.5rem;
  `,
}

export type TableLoadingProps = {
  className?: string
  cols?: number
  rows?: number
}

export function TableLoading(props: TableLoadingProps) {
  const { rows = PAGE_SIZE, cols = 5, className } = props

  return (
    <div
      style={{ "--cols": cols, "--rows": rows } as any}
      className={cx(styles.root, className)}
    >
      <div className={styles.grid}>
        {Array.from({ length: rows * cols }).map((_, i) => (
          <Skeleton key={i.toString()} variant="rect" height={20} />
        ))}
      </div>
    </div>
  )
}
